import { Component, ChangeDetectionStrategy } from '@angular/core'

import { TrygroupNgAnalysisExportSettingsPageComponent } from '../ng-analysis-export/trygroup-ng-analysis-export-settings-page.component'
import { TrygroupAccessLogExportSettingsPageComponent } from '../access-log-export/trygroup-access-log-export-settings-page.component'
import { TrygroupAccessReportExportSettingsPageComponent } from '../access-report-export/trygroup-access-report-export-settings-page.component'
import { TrygroupNgPatternResultsExportSettingsPageComponent } from '../ng-pattern-results-export/trygroup-ng-pattern-results-export-settings-page.component'

@Component({
  selector: 'app-trygroup-export-settings-page',
  standalone: true,
  imports: [
    TrygroupNgAnalysisExportSettingsPageComponent,
    TrygroupAccessLogExportSettingsPageComponent,
    TrygroupNgPatternResultsExportSettingsPageComponent,
    TrygroupAccessReportExportSettingsPageComponent,
  ],
  template: `
    <div class="export-sections">
      <app-trygroup-ng-analysis-export-settings-page />
      <app-trygroup-access-log-export-settings-page />
      <app-trygroup-ng-pattern-results-export-settings-page />
      <app-trygroup-access-report-export-settings-page />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .export-sections {
        display: flex;
        flex-direction: column;
        gap: 24px;
      }
    `,
  ],
})
export class TrygroupExportSettingsPageComponent {}
